import { createAction } from "@reduxjs/toolkit";
import {
    GET_LIVE_DATA,
    TOGGLE_LIVE_DATA,
    UPDATE_LIVE_DATA,
    SET_HALO_WIDTH,
    GET_LAST_UPDATED_LIVE_DATA,
    setLastUpdatedLiveDataAction,
    SET_LAST_UPDATED_LIVE_DATA
} from "./types";
import { updateLiveDataAction, toggleLiveDataAction, setHaloWidthAction } from "./types";

export const updateLiveDataToStore =
    createAction<updateLiveDataAction["payload"]>(UPDATE_LIVE_DATA);

export const toggleLiveData = createAction<toggleLiveDataAction["payload"]>(TOGGLE_LIVE_DATA);

export const getLiveData = createAction(GET_LIVE_DATA);

export const getLastUpdatedLiveData = createAction(GET_LAST_UPDATED_LIVE_DATA);

export const setLastUpdatedLiveData = createAction<setLastUpdatedLiveDataAction["payload"]>(
    SET_LAST_UPDATED_LIVE_DATA
);

export const setHaloWidth = createAction<setHaloWidthAction["payload"]>(SET_HALO_WIDTH);
